<!--
        modal-box CLASS names:-
        *** modal-xs | modal-sm | modal-lg
        *** modal-success | modal-error | modal-warning | modal-info | modal-question
        *** {none:default} | modal-design1 | modal-design2

        svgicon href "sprite-sheet.svg#" names:-
        *** icon-success | icon-error | icon-warning | icon-info | icon-question
    -->

<div *ngIf="message" class="popupMsg modal-box modal-xs modal-design1 modal-{{this.messageType}}"
  style="display: block;">
  <div class="modal-content">
    <div class="modal-header">
      <div class="modal-icon" *ngIf="(redirectParent == '' || url == '')">
        <svg class="svgicon">
          <use [attr.xlink:href]=xlinkHref> </use>
        </svg>
      </div>
      <div class="modal-title" *ngIf="messageType == 'success'">{{heading != '' ? heading : ('common.awesome' | translate)}}</div>
      <div class="modal-title" *ngIf="messageType == 'error'">{{heading != '' ? heading : ('common.oops' | translate)}}</div>
      <div class="modal-title" *ngIf="messageType == 'warning'">{{heading != '' ? heading : ('common.warning' | translate)}}</div>
      <div class="modal-title" *ngIf="messageType == 'info'">{{heading != '' ? heading : ('common.information' | translate)}}</div>
      <div class="modal-title" *ngIf="messageType == 'question'">{{heading != '' ? heading : ('common.r_u_sure' | translate)}}</div>
      <div class="modal-close" data-dismiss="modal" (click)="closeModal()"><span></span></div>
    </div>
    <div class="modal-body" *ngIf="(redirectParent == '' || url == '')">
      <div [innerHTML]="message.text | safeHtml"></div>
      <ng-container *ngIf="!(ticketNumber == '' || url == '')">
        <br>
        <div>{{'common.ticket_quote' | translate}}: {{ ticketNumber }}</div>
        <div>
          {{'common.ticket_check' | translate}}
          <a (click)="redirectToUrl()" class="link">{{'common.here' | translate}}</a>
        </div>
      </ng-container>
    </div>
    <div class="modal-body" *ngIf="!(redirectParent == '' || url == '')">
      <div [innerHTML]="message.text | safeHtml"></div>
    </div>
    <div class="modal-footer">
      <div class="buttonWrap" *ngIf="messageType == 'question'" (click)="disAgree()">
        <a>
          <div class="cancelBtn button">
            <div class="text">{{'common.cancel' | translate}}</div>
          </div>
        </a>
      </div>
      <div class="buttonWrap" *ngIf="messageType == 'question'" (click)="agree()">
        <a>
          <div class="goBtn button">
            <div class="text">{{'common.agree' | translate}}</div>
          </div>
        </a>
      </div>
      <div class="buttonWrap" *ngIf="messageType != 'question' && (redirectParent == '' || url == '')"
        (click)="closeModal()">
        <a>
          <div class="goBtn button">
            <div class="text">{{'common.ok' | translate}}</div>
          </div>
        </a>
      </div>
      <div class="buttonWrap" *ngIf="messageType != 'question' && !(redirectParent == '' || url == '')"
        (click)="redirectToParent(redirectParent)">
        <a>
          <div class="goBtn button">
            <div class="text">{{url}}</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>